// extracted by mini-css-extract-plugin
module.exports = {"summaryEmailStyle":"_11BmMI1AB5_sx1ormVAKn-"};